export default __webpack_public_path__ + "static/media/Search.c058b42c.png";